"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState } from "react"
import { styled } from "@mui/material/styles"
import styles from "./styles.module.scss"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid" // Grid version 2
import Header from "../shared/Header"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../lib/constants"
import { signUpEmailVar } from "../../../../graphql/reactiveVars"
import { useRouter, usePathname } from "next/navigation"

const SubscribeButton = styled(Button)(({ theme }) => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  minWidth: "110px",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textAlign: "center",
  textTransform: "unset",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  // "@media only screen and (min-width: 600px)": {
  //   fontSize: "16px",
  //   minWidth: "110px",
  // },
  // "&:hover": {
  //   backgroundColor: BLACK_COLOR_PUSHED,
  // },
}))

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: UI_STYLE_PRIMARY_BLUE_BLACK,
  },
  "& .MuiInput-underline:before": {
    borderBottom: "unset",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: UI_STYLE_PRIMARY_BLUE_BLACK,
  },
  "& .MuiInputLabel-root": {
    top: "-7px",
    color: "#929292",
  },

  "& .MuiInputLabel-shrink": {
    top: "0px !important",
    color: `${UI_STYLE_PRIMARY_BLUE_BLACK} !important`,
  },
  "& .MuiInput-root": {
    color: "#929292",
    "& fieldset": {},
    "&:hover fieldset": {
      borderColor: UI_STYLE_PRIMARY_BLUE_BLACK,
      color: `${UI_STYLE_PRIMARY_BLUE_BLACK} !important`,
    },
    "&.Mui-focused fieldset": {
      borderColor: UI_STYLE_PRIMARY_BLUE_BLACK,
      color: `${UI_STYLE_PRIMARY_BLUE_BLACK} !important`,
    },
  },
})

function SubscribeEmail() {
  const router = useRouter()

  const [email, setEmail] = useState("")
  const renderHeader = () => {
    return <Header text="get unique mental health groups to your inbox monthly" />
  }

  const renderSubscribeTextfieldOption2 = () => {
    return (
      <div className={styles["textfield-and-button-container"]}>
        <div className={styles["inner"]}>
          <CssTextField
            fullWidth
            label="Your email"
            variant="standard"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value)
            }}
            placeholder="Your email"
          />
          <SubscribeButton
            onClick={() => {
              console.log("subscribe button clicked")
              if (email) {
                signUpEmailVar(email)
              }
              router.push("/signup?redirect_to_leader=true&newsletter=true")
            }}
          >
            Subscribe
          </SubscribeButton>
        </div>
      </div>
    )
  }

  return (
    <div className={styles["container"]}>
      <Container disableGutters maxWidth={"lg"}>
        <Grid
          container
          spacing={2}
          columns={9}
          sx={{
            justifyContent: "center",
            margin: 0,
          }}
        >
          <Grid
            size={8}
            sx={{
              padding: 0,
            }}
          >
            {renderHeader()}
            {renderSubscribeTextfieldOption2()}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
export default SubscribeEmail
